import { CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import img from "../../views/Login/img/unlocked.gif";
import img2 from "../../views/Login/img/wrong.png";
import { useContext} from 'react'
import systemContext from '../../AppState/SystemConfig/appContext';

export default function TokenValidateDialog({ validated,isloading }) {

   const {AppManager} =useContext(systemContext);

   useEffect(() => {


   }, [AppManager]);
  return (
    <div
      id="divShareData"
      className="modal fade-in"
      tabIndex="1"
      role="dialog"
      aria-hidden="true"
      style={{ backgroundColor: "#0000007a", display: "block" }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: "500px" }}>
        <div className="modal-content position-relative">
          { isloading?
            <div style={{ height: 300, display: "flex", justifyContent: "center", alignItems: "center" }}>
              <CircularProgress></CircularProgress>
             
            </div> :
          validated && !isloading ? (
            <div style={{ height: 300, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                   
              <img src={img} alt="" srcset="" style={{ width: 300 }} />
       
            </div>
          ) :  <div style={{ height: 300, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
             <img src={img2} alt="" srcset="" style={{ width: 300 }} />
             <Typography variant="body1" fontWeight="bold" color="#a99b9bdd" mt={2}>{AppManager.translator.current_lang === "es" ?"Token no valido":"Token not validated"}</Typography>
     
        </div>}

       
        </div>
      </div>
    </div>
  );
}
